import { useState } from "react";
import axios from "axios";
import { AlertCircle, ChevronRight, ClipboardList, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/shopee-shipping-report/return-cases/mistakes/mine`;
export const fmtLong = (s) => { const d = new Date(s); return isNaN(d) ? "-" : d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }); };

function MistakeCard({ r, all, i }) {
  const [open, setOpen] = useState(false);
  return <li>
    <button type="button" className={`mk-card${open ? " is-open" : ""}`} onClick={() => setOpen(v => !v)} aria-expanded={open} data-testid={`my-mistake-row-${i}`}>
      <AlertCircle className="mk-ic" size={20} aria-hidden="true"/>
      <span className="mk-main">
        <b className="mk-sn">{r.order_sn || r.return_sn}</b>
        <span className="mk-date">{fmtLong(r.date)}</span>
        <span className="mk-what">Kesalahan: {r.mistake || "-"}</span>
        {open ? <span className="mk-detail" data-testid={`my-mistake-detail-${i}`}>
          <span>Bagian: {r.stage || "-"}</span>
          {all && <span>Penanggung jawab: {(r.responsible || []).join(", ") || "-"}</span>}
          {r.detail && <span>Penyelesaian: {r.detail}</span>}
        </span> : <span className="mk-more">Ketuk untuk melihat rincian <ChevronRight size={14} aria-hidden="true"/></span>}
      </span>
    </button>
  </li>;
}

// Riwayat Kesalahan Saya — hanya keputusan retur yang sudah Ditetapkan; backend membatasi ke akun sendiri (Owner: semua).
export function MyMistakesButton() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const open = async () => {
    setData({ rows: [], loading: true }); setErr("");
    try { setData((await axios.get(API, { withCredentials: true })).data); }
    catch (e) { setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Gagal memuat riwayat"); setData({ rows: [] }); }
  };
  const n = data?.rows?.length || 0;
  return <>
    <button type="button" className="soft-btn small-btn" onClick={open} title="Riwayat Kesalahan Saya" data-testid="my-mistakes-btn">
      <ClipboardList size={15}/><span className="desk-only"> Riwayat Kesalahan</span></button>
    {data && <div className="mk-backdrop" onClick={(e) => e.target === e.currentTarget && setData(null)} data-testid="my-mistakes-modal">
      <div className="mk-modal" role="dialog" aria-modal="true" aria-labelledby="mk-title">
        <div className="mk-head">
          <h3 id="mk-title">{data.all ? "Riwayat Kesalahan Karyawan" : "Riwayat Kesalahan Saya"}</h3>
          {!data.loading && !err && <span className="mk-count" data-testid="my-mistakes-count">{n} kesalahan</span>}
          <button type="button" className="mk-close" onClick={() => setData(null)} aria-label="Tutup" data-testid="my-mistakes-close"><X size={18}/></button>
        </div>
        <div className="mk-body">
          {data.loading ? <p className="muted">Memuat…</p> : err ? <p className="alert" data-testid="my-mistakes-error">{err}</p>
            : n === 0 ? <p className="muted" data-testid="my-mistakes-empty">Belum ada kesalahan yang ditetapkan.</p>
            : <ul className="mk-list">{data.rows.map((r, i) => <MistakeCard key={r.return_sn || i} r={r} all={data.all} i={i}/>)}</ul>}
        </div>
      </div>
    </div>}
  </>;
}
